/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelinePaymentTypeDto } from './traveline-payment-type-dto';
import {
    TravelinePaymentTypeDtoFromJSON,
    TravelinePaymentTypeDtoFromJSONTyped,
    TravelinePaymentTypeDtoToJSON,
    TravelinePaymentTypeDtoToJSONTyped,
} from './traveline-payment-type-dto';

/**
 * Prepayment entity
 * @export
 * @interface TravelineBookingPrepaymentDto
 */
export interface TravelineBookingPrepaymentDto {
    /**
     * Comment to payment
     * @type {string}
     * @memberof TravelineBookingPrepaymentDto
     */
    remark?: string | null;
    /**
     * 
     * @type {TravelinePaymentTypeDto}
     * @memberof TravelineBookingPrepaymentDto
     */
    paymentType?: TravelinePaymentTypeDto;
    /**
     * Amount of payment actually received from the guest in the channel.
     * @type {number}
     * @memberof TravelineBookingPrepaymentDto
     */
    prepaidSum?: number | null;
}



/**
 * Check if a given object implements the TravelineBookingPrepaymentDto interface.
 */
export function instanceOfTravelineBookingPrepaymentDto(value: object): value is TravelineBookingPrepaymentDto {
    return true;
}

export function TravelineBookingPrepaymentDtoFromJSON(json: any): TravelineBookingPrepaymentDto {
    return TravelineBookingPrepaymentDtoFromJSONTyped(json, false);
}

export function TravelineBookingPrepaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingPrepaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'remark': json['remark'] == null ? undefined : json['remark'],
        'paymentType': json['paymentType'] == null ? undefined : TravelinePaymentTypeDtoFromJSON(json['paymentType']),
        'prepaidSum': json['prepaidSum'] == null ? undefined : json['prepaidSum'],
    };
}

  export function TravelineBookingPrepaymentDtoToJSON(json: any): TravelineBookingPrepaymentDto {
      return TravelineBookingPrepaymentDtoToJSONTyped(json, false);
  }

  export function TravelineBookingPrepaymentDtoToJSONTyped(value?: TravelineBookingPrepaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remark': value['remark'],
        'paymentType': TravelinePaymentTypeDtoToJSON(value['paymentType']),
        'prepaidSum': value['prepaidSum'],
    };
}

